export const PAGE_LIMIT = 10
export const DROP_DOWN_LIST_LIMIT = 7
